import i18n from 'es2015-i18n-tag';
import Button from '../../../../../common/ui-components/button/button.component';
import PrimaryButton from '../../../../../common/ui-components/primary-button/primary-button.component';
import './close-survey-dialog.component.scss';

export const CloseSurveyDialog = ({ onCancel, onConfirm }) => (
    <div className="close-survey-dialog">
        <h1 className="close-survey-dialog__title">{i18n`Umfrage abschließen?`}</h1>
        <div className="close-survey-dialog__actions">
            <Button title="Nein" onClick={onCancel} />
            <PrimaryButton title="Ja" onClick={onConfirm} />
        </div>
    </div>
);
